import React, { useContext } from 'react';

import { usePresetPermissions } from 'components/Presets/hooks/usePresetPermissions';

import { Actions, Action, Grid, DeleteIcon } from '@gogame/components';
import Permissions from '@gogame/permissions';

import { PresetsContext } from '../../PresetsContext';
import {
  ACTION_UPDATE_PRESET,
  ACTION_RESET_PRESET,
  ACTION_SHARE_PRESET,
  ACTION_UNSHARE_PRESET,
  ACTION_DELETE_PRESET,
  ACTION_RENAME_PRESET,
} from './constants';

const ActionsComponent = ({
  isActive,
  isPublic,
  isOwner,
  onReset,
  onUpdate,
  onShare,
  onUnshare,
  onRename,
  onDelete,
  labelReset = 'Reset',
  labelUpdate = 'Update',
}) => {
  const { isChanged } = useContext(PresetsContext);
  const actions = usePresetPermissions({
    isActive,
    isChanged,
    isPublic,
    isOwner,
  });

  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <Grid container>
          <Actions limit={2}>
            {isActionAllowed(ACTION_RESET_PRESET) ? (
              <Action button={true} label={labelReset} onClick={onReset} />
            ) : null}

            {isActionAllowed(ACTION_UPDATE_PRESET) ? (
              <Action button={true} label={labelUpdate} onClick={onUpdate} />
            ) : null}
          </Actions>
          <Actions limit={0}>
            {isActionAllowed(ACTION_UNSHARE_PRESET) ? (
              <Action id={'share'} label={'Unshare'} onClick={onUnshare} />
            ) : null}
            {isActionAllowed(ACTION_SHARE_PRESET) ? (
              <Action id={'share'} label={'Share'} onClick={onShare} />
            ) : null}
            {isActionAllowed(ACTION_RENAME_PRESET) ? (
              <Action label={'Rename'} onClick={onRename} />
            ) : null}

            {isActionAllowed(ACTION_DELETE_PRESET) ? (
              <Action
                id={'remove'}
                icon={<DeleteIcon />}
                label={'Delete'}
                onClick={onDelete}
              />
            ) : null}
          </Actions>
        </Grid>
      )}
    </Permissions>
  );
};

export default ActionsComponent;
